import API from "./baseApi";

const getMemberBenefits = (payload) => {
  return API.get(`/member-benefits/parent?program_id=${payload}`);
};

const updateParentMemberBenefits = (id, payload) => {
  return API.put(`/member-benefits/parent/${id}`, payload);
};

const updateIndividualMemberBenefits = (id, payload) => {
  return API.put(`/member-benefits/individual/${id}`, payload);
};

//v2
const getMemberBenefitsv2 = (payload) => {
  return API.get(`/member-benefitsv2/master?program_id=${payload}`);
};

const updateMasterMemberBenefitsv2 = (id, payload) => {
  return API.put(`/member-benefitsv2/update-master-benefit/${id}`, payload);
};



export default {
  getMemberBenefits,
  updateParentMemberBenefits,
  updateIndividualMemberBenefits,

  getMemberBenefitsv2,
  updateMasterMemberBenefitsv2
};
